import React from 'react';
import PropTypes from 'prop-types';
import Popup from '../../../components/reusable/Popups/Popup';

const ConfirmDialog = ({ onClose, onConfirm }) => (
  <Popup type="budget" onClose={onClose} onClick={onConfirm} />
);

ConfirmDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmDialog;